import React, {useCallback, useReducer, useEffect, useContext, useMemo, useState} from 'react';
import {reducer, INITIAL_STATE, actions} from './state';
import {Paginator} from '../../components/molecules';
import {useSnackbar} from 'react-simple-snackbar';
import {Loader} from '../../components/atoms';
import {api, api_pdf, Context} from '../../services';
import {motion} from 'framer-motion';
import {config} from '../../assets';
import {Footer} from './components';
import Header from '../formulario/components/header';
import {isMobile} from 'react-device-detect';
import swal from 'sweetalert';

import createForm from './components/forms';
import dayjs from 'dayjs';

const variants = {
  visible: {opacity: 1, display: 'flex'},
  hidden: {opacity: 0, transitionEnd: {display: 'none'}},
};

const Formulario = ({history, location}) => {
  const urlParams = new URLSearchParams(location.search);
  const uuid_segurado = urlParams.get('s');
  const cnpj_corretor_vistoria = urlParams.get('cnpj');
  const cnpj_corretor = urlParams.get('c');
  const isCampaign = urlParams.get('isCampaign');
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);
  const [authState] = useContext(Context);
  const [open] = useSnackbar(config.snackbar_error);
  const [openSnackSuccess] = useSnackbar(config.snackbar_success);

  const [modalAtual, setModalAtual] = useState(false);

  const [isEdit, setIsEdit] = useState(false);

  const [size, setSize] = useState(0);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [gerouCotacao, setGerouCotacao] = useState(false);

  const [imgLoading, setImgLoading] = useState(false);
  const [sucessFoto, setSucessFoto] = useState(false);

  const [isClicked, setIsClicked] = useState(false);

  const [cadastradoCampanha, setCadastradoCampanha] = useState(false);

  const {forms, refs} = useMemo(() => createForm(+!!authState.token || +!!cnpj_corretor), [authState.token, cnpj_corretor]);

  const checkAdvance = useCallback((payload) => {
    dispatch({type: actions.CHANGE_ADVANCE_STATUS, payload});
  }, []);

  const changeButtonStatus = useCallback((payload) => {
    dispatch({type: actions.CHANGE_BUTTON_STATUS, payload});
  }, []);

  const validateValorBike = useCallback(() => {
    try {
    } catch (e) {
      dispatch({type: actions.BIKE_ERROR});
    }
  }, []);
  /* 
  useEffect(() => {
    swal({
      title: 'Atenção!',
      text: 'Informamos que o atendimento via chat está temporariamente suspenso. Pedimos desculpas por qualquer inconveniente e agradecemos sua compreensão.',
      icon: 'warning',
    });
  }, []);
 */
  const onAdvance = useCallback(
    (modal) => {
      const isValue = state.current < refs.length;
      let payload = isValue && refs[state.current].current?.values();

      // modal === 2 BICI SURA Essencial

      if (modal === 0 || modal === 1 || modal === 2 || modal === 3) {
        payload.data.modal = modal;
        setModalAtual(modal);
        if (isCampaign) {
          function gtag_report_conversion(url) {
            var callback = function () {
              if (typeof url != 'undefined') {
                window.location = url;
              }
            };
            window.gtag('event', 'conversion', {
              send_to: 'AW-10999123839/dNXyCILwteUDEP-e5fwo',
              event_callback: callback,
            });
            return false;
          }
          gtag_report_conversion();
        }
      }

      if (state.current === 1) {
        dispatch({type: actions.VALIDATING_BIKE});
        validateValorBike();
      }

      dispatch({type: actions.ADVANCE, payload});
    },
    [state, refs, validateValorBike],
  );

  const onSetBikeId = useCallback(
    (id_bike) => {
      dispatch({type: actions.SET_BIKE_ID, payload: id_bike});
    },
    [state, refs, validateValorBike],
  );

  const onRegress = useCallback(() => {
    dispatch({type: actions.REGRESS});
  }, []);

  const onSubmitReduzido = useCallback(async () => {
    try {
      await api.post(
        '/segurado/sura_corretor/cadastro_reduzido',
        {
          ...state.data,
          is_campaign: state.data.is_campaign ? state.data.is_campaign : isCampaign ? 1 : 0,
          data_nasc: dayjs(state.data.data_nasc, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          cnpj_corretor,
        },
        {headers: {authorization: authState.token}},
      );
    } catch (e) {
      console.log(e);
    }
  }, [authState.token, state.data]);

  const onSubmit = useCallback(
    async ({tipo}) => {
      setIsClicked(true);
      setPdfLoading(true);
      try {
        const {data: resp} = await api.post(
          '/segurado/sura_corretor/cadastro',
          {
            ...state.data,
            is_campaign: isCampaign ? 1 : 0,
            cupom: {code: state.data.cupom.code},
            data_nasc: dayjs(state.data.data_nasc, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            observacao: authState.obs,
            tipo_notificacao: tipo,
            cnpj_corretor,
          },
          {headers: {authorization: authState.token}},
        );

        if (isCampaign) {
          function gtag_report_conversion(url) {
            var callback = function () {
              if (typeof url != 'undefined') {
                window.location = url;
              }
            };
            window.gtag('event', 'conversion', {
              send_to: 'AW-10999123839/_8t0CJ3wteUDEP-e5fwo',
              transaction_id: '',
              event_callback: callback,
            });
            return false;
          }
          gtag_report_conversion();
        }

        if (tipo === 'sms') {
          openSnackSuccess('Notificação enviada com sucesso.', 3000);
        } else if (tipo === 'link') {
          openSnackSuccess('Link criado. Gerando PDF, aguarde..', 5000);
        } else if (tipo === 'pdf') {
          openSnackSuccess('Gerando PDF, aguarde..', 5000);
        }
        console.log({uuid: resp.data.uuid});

        if (resp.data.uuid) {
          const {data: resp_pdf} = await api_pdf.post(
            `/ordem_servico/sura/corrigir_pdf/${resp.data.uuid}`,
            {
              ...state.data,
              is_campaign: state.data.is_campaign ? state.data.is_campaign : isCampaign ? 1 : 0,
              cupom: {code: state.data.cupom.code},
              data_nasc: dayjs(state.data.data_nasc, 'DD/MM/YYYY').format('YYYY-MM-DD'),
              observacao: authState.obs,
              tipo_notificacao: tipo,
              cnpj_corretor,
            },
            {headers: {authorization: authState.token, 'ngrok-skip-browser-warning': '69420'}},
          );

          setTimeout(() => {
            setPdfLoading(false);
            window.open(resp_pdf.data.link_proposta, '_blank');
          }, 5000);
        }

        if (tipo === 'link') {
          if (cnpj_corretor) {
            setTimeout(() => {
              setPdfLoading(false);
              window.open(resp.data.link_formulario + `&cnpj=` + cnpj_corretor, '_blank');
            }, 5000);
          } else {
            setTimeout(() => {
              setPdfLoading(false);
              window.open(resp.data.link_formulario, '_blank');
            }, 5000);
          }
        }

        dispatch({
          type: actions.SUCCESS_SUBMIT,
          payload: {link: cnpj_corretor ? resp.data.link_formulario + `&cnpj=` + cnpj_corretor : resp.data.link_formulario},
        });
      } catch (e) {
        setPdfLoading(false);
        dispatch({type: actions.ERROR_SUBMIT, payload: e.message});
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [authState.token, openSnackSuccess, state.data, history],
  );

  const onSubmitQuote = useCallback(
    async ({tipo}) => {
      openSnackSuccess('Salvando cotação, aguarde..', 5000);
      try {
        const {data: resp} = await api.post(
          '/segurado/sura_corretor/cadastro_cotacao',
          {
            ...state.data,
            is_campaign: isCampaign ? 1 : 0,
            cupom: {code: state.data.cupom.code},
            data_nasc: dayjs(state.data.data_nasc, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            observacao: authState.obs,
            cnpj_corretor,
          },
          {headers: {authorization: authState.token}},
        );

        openSnackSuccess('Gerando PDF, aguarde..', 10000);

        console.log(resp.data.uuid);

        if (resp.data.uuid) {
          const {data: resp_pdf} = await api_pdf.post(
            `/ordem_servico/sura/corrigir_pdf_cotacao/${resp.data.uuid}`,
            {},
            {
              headers: {authorization: authState.token, 'ngrok-skip-browser-warning': '69420'},
            },
          );

          setTimeout(() => {
            setPdfLoading(false);
            window.open(resp_pdf.data.link_proposta, '_blank');
          }, 5000);
        }

        setGerouCotacao(true);
      } catch (e) {
        setGerouCotacao(false);
        dispatch({type: actions.ERROR_SUBMIT, payload: e.message});
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [authState.token, openSnackSuccess, state.data, history],
  );

  const onSubmitFotos = useCallback(async () => {
    try {
      setImgLoading(true);
      //dispatch({type: actions.START_SUBMIT_SEGURADO, payload: {}});
      const isValue = state.current < refs.length;
      const payload = isValue && refs[state.current].current?.values();
      const {fotos} = payload.data;
      const {coords, bike_selecionada} = state.data;

      const formData = new FormData();

      formData.append('uuid', uuid_segurado);
      formData.append('id_bike', bike_selecionada);
      formData.append('coords', JSON.stringify({...coords}));
      Object.entries(fotos).forEach(([tipo, file]) => {
        formData.append('fotos', file);
        formData.append('tipos', tipo);
      });

      await api.post('segurado/sura_corretor/atualizar_fotos', formData);

      const {data: resp_pdf} = await api_pdf.post(
        `/ordem_servico/sura/corrigir_pdf/${uuid_segurado}`,
        {},
        {
          headers: {authorization: authState.token, 'ngrok-skip-browser-warning': '69420'},
        },
      );
      dispatch({type: actions.SUCCESS_SUBMIT_FOTOS, payload: bike_selecionada});
      setImgLoading(false);
      setSucessFoto(!sucessFoto);
    } catch (e) {
      setImgLoading(false);
      console.log(e);
      openSnackSuccess('Algum erro ocorreu.', 5000);
      dispatch({type: actions.ERROR_SUBMIT, payload: 'Erro ao enviar fotos. Por favor, tente novamente mais tarde!'});
    }
  }, [openSnackSuccess, refs, state, uuid_segurado]);

  const onSubmitSegurado = useCallback(async () => {
    try {
      dispatch({type: actions.START_SUBMIT_SEGURADO, payload: {}});
      const isValue = state.current < refs.length;
      const payload = isValue && refs[state.current].current?.values();
      const {pagamento} = payload.data;

      if (pagamento.forma_pagamento === 'c') {
        const [expiration_month, expiration_year] = pagamento.validade.split('/');

        const {data: auth} = await api.get('pagamentos/autenticar');

        if (auth.status !== 200) throw new Error(auth.message);

        const {data: token} = await api.post('pagamentos/token', {card_number: pagamento.numero, token: auth.data});

        if (!token.data?.number_token) throw new Error(token.message);

        await api.post('segurado/sura_corretor/atualizar_pagamento', {
          pagamento: {
            ...pagamento,
            bin: pagamento.numero.substr(0, 6),
            number_token: token.data.number_token,
            expiration_month,
            expiration_year,
          },
          uuid: uuid_segurado,
          token: auth.data,
        });
      } else {
        await api.post('segurado/sura_corretor/atualizar_pagamento', {pagamento, uuid: uuid_segurado});
      }

      onAdvance();

      dispatch({type: actions.SUCCESS_SUBMIT, payload: {}});
    } catch (e) {
      console.log(e);
      open('Algum erro ocorreu.', 3000);
      dispatch({type: actions.ERROR_SUBMIT, payload: e.message});
    }
  }, [onAdvance, open, refs, state, uuid_segurado]);

  const onError = useCallback(
    (message) => {
      open(message, 1000);
      dispatch({type: actions.CLEAN_ERROR});
    },
    [open],
  );

  const goTo = useCallback(
    (position) => () => {
      dispatch({type: actions.GO_TO, payload: position});
    },
    [],
  );

  // HOTFIX WRONG CORRETOR CNPJ
  useEffect(() => {
    if (cnpj_corretor && cnpj_corretor === '7265171000191') {
      history.push('formulario?c=72651710000191');
    }
  });

  const onAddEquipament = useCallback((go_to) => {
    dispatch({type: actions.ADD_EQUIPMENT, payload: {current: go_to}});
  }, []);

  const onRemoveEquipment = useCallback((index) => {
    dispatch({type: actions.REMOVE_EQUIPMENT, payload: {index}});
  }, []);

  const onSetEquipmentToUpdate = useCallback((index) => {
    dispatch({type: actions.SET_EQUIPMENT_TO_UPDATE, payload: {index}});
    setIsEdit(true);
  }, []);

  // Buscar informações iniciais (coberturas, fabricantes e modalidades)
  useEffect(() => {
    let mounted = true;
    const loadData = async () => {
      try {
        let respCorretor;
        if (cnpj_corretor) {
          const {data: rCorretor} = await api.get(
            `segurado/sura_corretor/valida_cnpj/${cnpj_corretor === '7265171000191' ? '72651710000191' : cnpj_corretor}`,
          );
          respCorretor = rCorretor;
        }

        let {data: resp} = await api.get(`segurado/sura_lojista/${state.data.modal === 3 ? 6 : 1}`);

        console.log(resp);

        if (cnpj_corretor) {
          resp.data.logoParceiro = respCorretor.data.logoParceiro;

          if (isCampaign) {
            resp.data.capaParceiro = respCorretor.data.capaParceiro;
            resp.data.corPrimaria = respCorretor.data.corPrimaria;
            resp.data.corSecundaria = respCorretor.data.corSecundaria;
          }
        }

        if (resp.status !== 200) throw new Error(resp.message);
        mounted && dispatch({type: actions.RENDER, payload: resp.data});
      } catch (e) {
        console.log(e);
        history.replace('/corretor/erro');
      }
    };

    if (authState.token || cnpj_corretor || state.data.modal === 3) loadData();
    return () => (mounted = false);
  }, [authState.token, cnpj_corretor, history, state.data.modal]);

  // Valida UUID do Segurado (fluxo de vistoria)
  useEffect(() => {
    let mounted = true;
    const loadData = async () => {
      try {
        const {data: resp} = await api.get(`segurado/sura_corretor/valida_uuid/${uuid_segurado}`);

        let respCorretor;
        if (cnpj_corretor_vistoria) {
          const {data: rCorretor} = await api.get(
            `segurado/sura_corretor/valida_cnpj/${
              cnpj_corretor_vistoria === '7265171000191' ? '72651710000191' : cnpj_corretor_vistoria
            }`,
          );
          respCorretor = rCorretor;
        }

        let total = 0;

        resp.data.cobertura.forEach((c) => {
          total += +c.cobertura_segurado.valor;
        });

        resp.data.total = total;

        if (resp.status !== 200) throw new Error(resp.message);

        mounted &&
          dispatch({
            type: actions.RENDER,
            payload: cnpj_corretor_vistoria
              ? {
                  segurado: resp.data,
                  uuid: uuid_segurado,
                  logoParceiro: respCorretor.data.logoParceiro,
                  capaParceiro: respCorretor.data.capaParceiro,
                  corPrimaria: respCorretor.data.corPrimaria,
                  corSecundaria: respCorretor.data.corSecundaria,
                }
              : {
                  segurado: resp.data,
                  uuid: uuid_segurado,
                },
          });
      } catch (e) {
        console.log(e);
        history.replace('/corretor/erro');
      }
    };

    if (uuid_segurado) loadData();
    else if (cnpj_corretor) console.log();
    else if (!authState.token) history.replace('/corretor/erro');
    return () => (mounted = false);
  }, [history, uuid_segurado, authState.token, cnpj_corretor]);

  // Começar o submit
  useEffect(() => {
    if (state.submiting) onSubmit();
  }, [state.submiting, onSubmit]);

  // Começar o submit
  useEffect(() => {
    if (state.current === 2 && !uuid_segurado) onSubmitReduzido();
  }, [state.current, onSubmitReduzido]);

  useEffect(() => {
    if (state.error?.length > 0) onError(state.error);
  }, [state.error, onError]);

  useEffect(() => {
    const height = parseInt(refs[state.current].current?.ref?.current?.getBoundingClientRect().height) + 200;

    if (height && height !== size) {
      setSize(height);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refs, size, state.current, state.render]);

  const onSetTotalBike = useCallback((total) => {
    dispatch({type: actions.SET_TOTAL_TO_BIKE, payload: {total}});
  }, []);

  const cadastra_campanha = () => {
    if (!cadastradoCampanha) setCadastradoCampanha(true);
    return cadastradoCampanha;
  };

  return (
    <div className="mainContainer">
      {state.render ? (
        <div className="h-100">
          <Header
            current={state.current}
            isSegurado={!!uuid_segurado}
            logoParceiro={state.extra_data.logoParceiro}
            isModal={state.data?.modal}
            corPrimaria={state.extra_data.corPrimaria}
            token={authState.token}
          />
          <div className="bodyContainer">
            <div className="formCardCustom" style={{height: !isMobile || size === 0 ? '95%' : size + 'px'}}>
              <Paginator
                className="content"
                current={state.current}
                extraData={{
                  ...state.extra_data,
                }}
                data={state.data}
                isAdvance={state.is_advance}
                success={state.success_submit}
                onSubmit={onSubmit}
                onSubmitSegurado={onSubmitSegurado}
                onSubmitQuote={onSubmitQuote}
                regress={onRegress}
                goTo={goTo}
                checkAdvance={checkAdvance}
                onAdvance={onAdvance}
                changeButtonStatus={changeButtonStatus}
                onRemoveEquipment={onRemoveEquipment}
                onSetEquipmentToUpdate={onSetEquipmentToUpdate}
                onSetBikeId={onSetBikeId}
                onSetTotalBike={onSetTotalBike}
                isEdit={isEdit}
                setIsEdit={setIsEdit}
                loading={pdfLoading}
                sucessFoto={sucessFoto}
                capaParceiro={state.extra_data.capaParceiro}
                corPrimaria={state.extra_data.corPrimaria}
                uuid_segurado={uuid_segurado}
                cnpj_corretor={cnpj_corretor}
                modalAtual={modalAtual}
                canAdvance={state.canAdvance}
                gerouCotacao={gerouCotacao}
                isCampaign={isCampaign}>
                {forms}
              </Paginator>
              <motion.div
                className="overflow"
                initial="hidden"
                animate={state.submiting || state.submiting_segurado ? 'visible' : 'hidden'}
                variants={variants}>
                <Loader color={!!state.extra_data.corPrimaria ? state.extra_data.corPrimaria : '#023a86'} />
              </motion.div>
              <Footer
                lock={state.lock}
                current={state.current}
                canAdvance={state.canAdvance}
                canRegress={state.canRegress}
                success={state.success_submit}
                onAdvance={onAdvance}
                onSubmitReduzido={onSubmitReduzido}
                onSubmit={onSubmit}
                onRegress={onRegress}
                isSegurado={!!uuid_segurado}
                onSubmitSegurado={onSubmitSegurado}
                onAddEquipament={onAddEquipament}
                goTo={goTo}
                onSubmitFotos={onSubmitFotos}
                loading={pdfLoading}
                imgLoading={imgLoading}
                isClicked={isClicked}
                extraData={state.extra_data}
                corPrimaria={state.extra_data.corPrimaria}
                isCampaign={isCampaign}
                cadastraCampanha={cadastra_campanha}
                gerouCotacao={gerouCotacao}
                token={authState.token}
              />
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default Formulario;
